import { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { UBAppModal } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import TabAutoComplete from "../../../../Libraries/TabAutoComplete";
import styles from "./styles.modules.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const themeList = [
  { label: "Light mode", value: "light" },
  { label: "Dark mode", value: "dark" },
];

const AppearanceModal = ({ open, onClose, onConfirm, loading, value }) => {
  const [themeCode, setThemeCode] = useState(value || "");
  const [I18n] = useContext(LanguageContext);

  const selectedLabel = themeList.find((t) => t.value === themeCode)?.label || "";

  useEffect(() => {
    if (open) setThemeCode(value || "");
  }, [open]);

  return (
    <UBAppModal
      id="appearance_modal"
      open={open}
      header={{
        title: "change_appearance",
        handleClose: onClose,
        dont_show_cross_icon: true,
      }}
      className={`${styles.changeCategoryModal} changeCategoryModal`}
      footer={[
        {
          data: {
            className: "ubSecondaryButton",
            title: I18n.cancel,
            onClick: onClose,
            id: `AppearanceModal_cancel`,
          },
        },
        {
          data: {
            className: "ubPrimaryButton fontSize12 fontWeight400 bgPrimary",
            title: I18n.save,
            onClick: () => {
              triggerLogEvent(analytics, "setting_appearance_theme_saved", { theme: themeCode });
              onConfirm(themeCode);
            },
            disabled: !Boolean(themeCode) || loading,
            loading,
            id: `AppearanceModal_confirm`,
          },
        },
      ]}
    >
      <Box>
        <TabAutoComplete
          className={styles.dropdownContainer}
          id={"AppearanceModal_theme"}
          list={themeList}
          label={I18n.select_theme}
          handleSelect={(item) => {
            triggerLogEvent(analytics, "setting_appearance_theme_selected", { theme: item?.value || "" });
            setThemeCode(item?.value || "");
          }}
          value={selectedLabel}
          placeholder={I18n.select_theme}
        />
      </Box>
    </UBAppModal>
  );
};

export default AppearanceModal;
